import {
    Route,
    Routes,
} from 'react-router-dom';
import {RequirePermission} from '../../utils/RequirePermission.tsx';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from './pages/EditPage.tsx';
import {rbacActions} from '../../config/rbac/actions.ts';

export const TestingPersonasLayout = () => {

    return (
        <Routes>
            <Route
                path='/'
                element={
                    <RequirePermission action={rbacActions.ListTestingPersonas}>
                        <IndexPage/>
                    </RequirePermission>
                }
            />
            <Route
                path='add'
                element={
                    <RequirePermission action={rbacActions.CreateTestingPersona}>
                        <AddPage/>
                    </RequirePermission>
                }
            />
            <Route
                path=':id'
                element={
                    <RequirePermission action={rbacActions.GetTestingPersona}>
                        <EditPage/>
                    </RequirePermission>
                }
            />
        </Routes>
    );
};
